import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import "./Indicators.scss";

type FrameStatus = "loading" | "loaded" | "error";

const Indicators: FC = () => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(0);
  const [showingIFrame, setShowingIFrame] = useState(false);
  const [status, setStatus] = useState<FrameStatus>("loading");
  const domain = process.env.REACT_APP_DOMAIN;
  const WAIT_FOR_IFRAME_SHOW_IN_MS = 500;

  useEffect(() => {
    if (!domain) {
      setStatus("error");
      return undefined;
    }
    setHeight(ref?.current?.offsetHeight);
    const timer = setTimeout(() => {
      setShowingIFrame(true);
    }, WAIT_FOR_IFRAME_SHOW_IN_MS);
    return () => clearTimeout(timer);
  }, [domain]);

  return (
    <div className="container d-flex flex-column mb-0" data-testid="parent-el">
      <div ref={ref} className="iframe-wrapper">
        {status === "loading" && (
          <div className="indicators__state" role="status" aria-live="polite">
            <span className="spinner spinner-default-grey" />
          </div>
        )}
        {status === "error" && (
          <div className="indicators__state" role="alert">
            <p className="indicators__state-message">
              {t("indicatorsLoadError")}
            </p>
          </div>
        )}
        {showingIFrame && domain && status !== "error" && (
          <iframe
            id="iframe-id"
            title={t("indicatorsFrameTitle")}
            src={`${domain}/skarpliance/definition/7652/show?&o_=tnh`}
            referrerPolicy="no-referrer"
            onLoad={() => setStatus("loaded")}
            onError={() => setStatus("error")}
            style={{
              height,
              width: "100%",
              display: status === "loaded" ? "block" : "none",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Indicators;
